export default __webpack_public_path__ + "static/media/peck.be966c9c.svg";